import React, {RefObject} from 'react';
import {Button} from '@tickchak/react-share/app';
import * as css from '../AIMessageGenerator.css';
import AiGenerate from '../../../assets/icons/aiGenerate';
import type {TXHR} from '../../../assets/constants/constansts.type';

interface GeneratorPromptAreaProps {
    promptText: string;
    placeholder: string;
    disableSubmit: boolean;
    submitLabel: string;
    submitXhrState?: TXHR;
    promptTextareaRef: RefObject<HTMLTextAreaElement>;
    onPromptChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    onPromptKeyDown: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
    onSubmitPrompt: () => void;
}

/** Default prompt box — callers can replace it through `renderPromptArea`. */
function GeneratorPromptArea({
    promptText,
    placeholder,
    disableSubmit,
    submitLabel,
    submitXhrState,
    promptTextareaRef,
    onPromptChange,
    onPromptKeyDown,
    onSubmitPrompt,
}: GeneratorPromptAreaProps) {
    return (
        <css.promptArea>
            <css.promptTextarea
                ref={promptTextareaRef}
                value={promptText}
                onChange={onPromptChange}
                onKeyDown={onPromptKeyDown}
                placeholder={placeholder}
                data-testid="ai-message-generator-prompt"
                rows={1}
            />
            <Button
                disabled={disableSubmit}
                onClick={onSubmitPrompt}
                data-testid="ai-message-generator-submit"
                iconEnd={<AiGenerate />}
                size="category"
                variant="brand"
                xhrState={submitXhrState}
            >
                {submitLabel}
            </Button>
        </css.promptArea>
    );
}

export default GeneratorPromptArea;
